<script lang="ts">
  import { onMount } from "svelte";
  import FooterLogo from "../utils/assets/footer_logo.svelte";
  import SendIcon from "../utils/assets/send_icon.svelte";
  import { isOpen } from "../stores/widget";
  import {
    showInput,
    showSocketLoader,
    sendMessage,
    displayMessage,
    showThinking,
    selected_communication,
    user_details_form_submitted,
    messages,
    send_message_input_value,
    clearSendMessageInputValue,
    setSendMessageInputValue,
    user_email,
    is_logged_in,
    is_bot_detected,
  } from "../stores/chat";
  import { client_config } from "../stores/store";

  export let accentColor: string;
  export let isVerbafloLeadId: string | null;
  let isKeyboardOpen = false;
  let sendMessageFlag = false;
  let windowWidth: number;

  onMount(() => {
    windowWidth = window.innerWidth;
    const handleResize = () => (windowWidth = window.innerWidth);
    const handleFocus = () => {
      if (windowWidth < 700) {
        isKeyboardOpen = true;
        document.body.style.setProperty("height", "100vh", "important");
        document.body.style.setProperty("overflow", "hidden", "important");
        document.body.style.setProperty("position", "fixed", "important");
        document.body.style.setProperty("width", "100%", "important");
      }
    };

    const handleBlur = () => {
      if (windowWidth < 700) {
        isKeyboardOpen = false;
        if (!$isOpen) {
          document.body.style.removeProperty("height");
          document.body.style.removeProperty("overflow");
          document.body.style.removeProperty("position");
          document.body.style.removeProperty("width");
        }
      }
    };

    window.addEventListener("resize", handleResize);
    const inputs = document.querySelectorAll(".verbaflo-widget-input");
    inputs.forEach((input) => {
      input.addEventListener("focus", handleFocus);
      input.addEventListener("blur", handleBlur);
    });

    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("focus", handleFocus);
        input.removeEventListener("blur", handleBlur);
      });
    };
  });

  $: if ($isOpen && windowWidth < 700) {
    document.body.style.setProperty("height", "100vh", "important");
    document.body.style.setProperty("overflow", "hidden", "important");
    document.body.style.setProperty("position", "fixed", "important");
    document.body.style.setProperty("width", "100%", "important");
  } else if (!isKeyboardOpen) {
    document.body.style.removeProperty("height");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("width");
  }

  const handleKeyDown = () => {
    if (sendMessageFlag) {
      sendBatchedMessages();
    }
  };

  const sendBatchedMessages = () => {
    showThinking.set(true);
    sendMessage();
    sendMessageFlag = false;
  };

  const handleSubmit = (event: Event | null) => {
    if (event) event.preventDefault();
    if ($send_message_input_value?.trim()) {
      if ($is_bot_detected) {
        clearSendMessageInputValue();
      } else {
        sendMessageFlag = true;
        displayMessage($send_message_input_value?.trim());
        clearSendMessageInputValue();
        sendBatchedMessages();
      }
    }
  };
</script>

{#if $showSocketLoader}
  <div class="verbaflo-widget-loader-container">
    <div class="verbaflo-widget-loader-text">
      {$client_config?.reconnecting_label || "Reconnecting, please wait..."}
    </div>
  </div>
{:else if $selected_communication === "message"}
  {#if $user_details_form_submitted && $messages?.filter((m) => m.role === "user").length === 0 && $client_config?.suggested_questions?.length && !$user_email && !$is_logged_in && !isVerbafloLeadId}
    <div class="verbaflo-widget-preset-messages-container">
      {#each $client_config?.suggested_questions as message}
        <button
          class="verbaflo-widget-preset-btn"
          style="--accent-color: {accentColor};"
          on:click={() => {
            setSendMessageInputValue(message);
            handleSubmit(null);
          }}
        >
          {message}
        </button>
      {/each}
    </div>
  {/if}

  <div class="verbaflo-widget-footer-container">
    <span class="verbaflo-widget-footer-text">Powered by</span>
    <FooterLogo />
    <a
      href="https://verbaflo.ai"
      target="_blank"
      rel="noopener noreferrer"
      class="verbaflo-widget-footer-link"
    >
      VerbaFlo.
    </a>
  </div>

  {#if ($user_details_form_submitted && $showInput && $selected_communication === "message") || ($user_email && $is_logged_in) || isVerbafloLeadId}
    <div
      class="verbaflo-widget-input-container"
      style="border-color: {$send_message_input_value?.length > 1000
        ? 'red'
        : '#ededed'} !important"
    >
      <form on:submit={handleSubmit} class="verbaflo-widget-form-container">
        <div class="verbaflo-widget-input-wrapper">
          <input
            class="verbaflo-widget-input"
            placeholder={$client_config?.chat_box_input?.placeholder_text ||
              "Type your message..."}
            bind:value={$send_message_input_value}
            on:keydown={handleKeyDown}
            disabled={$showSocketLoader}
          />
        </div>
        <button
          type="submit"
          disabled={$showSocketLoader ||
            ($send_message_input_value?.length ?? 0) > 1000}
          class="verbaflo-widget-send-btn"
          style="--accent-color: {accentColor};"
        >
          <SendIcon />
        </button>
      </form>
    </div>
    {#if $send_message_input_value?.length > 1000}
      <div class="verbaflo-widget-input-error">
        {$client_config?.chat_box_input?.error_message ||
          "Message cannot exceed 1000 characters"} ({$send_message_input_value?.length}/1000)
      </div>
    {/if}
  {/if}
{/if}

<style>
  :global(#vfwidget .verbaflo-widget-loader-container) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 16px !important;
  }

  :global(#vfwidget .verbaflo-widget-loader-text) {
    color: #737373 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
  }

  :global(#vfwidget .verbaflo-widget-preset-messages-container) {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-end !important;
    margin-top: 4px !important;
    margin-right: 12px !important;
    margin-bottom: 12px !important;
    margin-left: 40px !important;
  }

  :global(#vfwidget .verbaflo-widget-preset-btn) {
    margin-bottom: 8px !important;
    padding: 8px !important;
    background-color: #ffffff !important;
    color: var(--accent-color) !important;
    border: 1px solid var(--accent-color) !important;
    border-radius: 4px !important;
    cursor: pointer !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    text-transform: none !important;
    opacity: 1 !important;
    text-align: left !important;
  }

  :global(#vfwidget .verbaflo-widget-preset-btn:hover),
  :global(#vfwidget .verbaflo-widget-preset-btn:active) {
    background-color: var(--accent-color) !important;
    color: #ffffff !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-footer-container) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    gap: 4px !important;
    margin: 6px 0 !important;
  }

  :global(#vfwidget .verbaflo-widget-footer-text) {
    color: #737373 !important;
    font-size: 10px !important;
    font-weight: 400 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  :global(#vfwidget .verbaflo-widget-footer-link) {
    text-decoration: none !important;
    color: #051133 !important;
    font-weight: bold !important;
    font-size: 12px !important;
    cursor: pointer !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  :global(#vfwidget .verbaflo-widget-input-container) {
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    border: 1px solid #ededed !important;
    border-radius: 8px !important;
    margin: 0 12px !important;
    padding: 4px !important;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait),
    only screen and (max-height: 500px) and (orientation: landscape) {
    :global(#vfwidget .verbaflo-widget-input-container) {
      position: sticky !important;
      bottom: 0 !important;
      background: white !important;
    }
  }

  :global(#vfwidget .verbaflo-widget-form-container) {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    gap: 8px !important;
    z-index: 20 !important;
  }

  :global(#vfwidget .verbaflo-widget-input-wrapper) {
    flex-grow: 1 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  :global(#vfwidget .verbaflo-widget-input) {
    flex-grow: 1 !important;
    font-size: 16px !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    color: #051133 !important;
    font-family: "Satoshi", sans-serif !important;
    font-weight: 400 !important;
    transform: scale(0.95) !important;
  }

  :global(#vfwidget .verbaflo-widget-input::placeholder) {
    color: #737373 !important;
    font-weight: 400 !important;
    font-family: "Satoshi", sans-serif !important;
    opacity: 0.8 !important;
  }

  :global(#vfwidget .verbaflo-widget-send-btn) {
    height: 40px !important;
    width: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 8px !important;
    background-color: var(--accent-color) !important;
    outline: none !important;
    border: none !important;
    cursor: pointer !important;
    padding: 0 !important;
    margin: 0 !important;
    transition: none !important;
  }

  :global(#vfwidget .verbaflo-widget-send-btn:hover) {
    background-color: var(--accent-color) !important;
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-send-btn:active) {
    background-color: var(--accent-color) !important;
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-send-btn:disabled) {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  }

  :global(#vfwidget .verbaflo-widget-input-error) {
    color: red !important;
    font-size: 12px !important;
    font-weight: 400 !important;
    margin: 4px 12px !important;
  }
</style>
